/** @format */

import React from "react";
import { Container, Row } from "reactstrap";

import CustomerForm from "./VerticalValidationWizard";

export default function AddCustomers({ customer_id }) {
  return (
    <div className="page-body main-project">
      <Container fluid className="mt-3">
        <Row>
          <CustomerForm customer_id={customer_id} />
        </Row>
      </Container>
    </div>
  );
}
